import { render, staticRenderFns } from "./modal-confirm.vue?vue&type=template&id=21474b76"
import script from "./modal-confirm.vue?vue&type=script&lang=js"
export * from "./modal-confirm.vue?vue&type=script&lang=js"
import style0 from "./modal-confirm.vue?vue&type=style&index=0&id=21474b76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports